export default "__VITE_ASSET__CMzEfEDL__"